<template>
  <div class="prediction-report-wrapper">
    <header-title :title="$t('aiPredictionReport.diseasePrediction')" />
    <!-- 疾病危険度 -->
    <section1>
      <heading
        :title="
          this.$i18n.t('aiPredictionReport.diseaseRisk') +
            ' ' +
            this.$i18n.t('yourPhysicalInformation.healthExamDate') +
            ' : ' +
            this.getDiagnosisDate
        "
        slot="heading"
      />

      <p v-text="$t('aiPredictionReport.tapOneToSeeTheDetail')" slot="text" />

      <div
        slot="cards"
        v-for="(diseaseRiskCard, index) in diseaseRiskCards"
        :key="index"
      >
        <disease-risk-card
          class="disease-risk-card"
          :index="index"
          :disease="diseaseRiskCard.disease"
          :risk_index="diseaseRiskCard.risk_index"
          :risk_rate="diseaseRiskCard.risk_rate"
        />
      </div>
    </section1>

    <!-- 健康年齢 -->
    <div class="content-wrapper">
      <section2 textcolor="#45A0DA" class="content--left">
        <heading
          :title="$i18n.t('aiPredictionReport.healthAge')"
          slot="heading"
        />

        <difference-from-real-age
          :healthAge="healthAge"
          :realAge="realAge"
          slot="text"
        />

        <value-with-unit
          :value="healthAge | round"
          :unit="$t('yourLifestyle.yearsOld')"
          slot="value-with-unit"
        />

        <line-chart-health-age
          slot="chart"
          :healthAge="healthAge"
          :realAge="realAge"
        />
      </section2>

      <!-- 期待生存率 -->
      <section3 class="content--right" textcolor="#838383" textcolor2="#45A0DA">
        <heading
          :title="$i18n.t('aiPredictionReport.expectedSurvivalRate')"
          slot="heading"
        />

        <!-- 平均 -->
        <average-survival-rate-text :gender="genderCode" slot="text1" />
        <value-with-unit
          :value="(100 - averageExpectedSurvivalRate) | round"
          unit="%"
          slot="value-with-unit1"
        />

        <!-- ユーザー -->
        <user-survival-rate-text :userName="userName" slot="text2" />
        <value-with-unit
          :value="(100 - userExpectedSurvivalRate) | round"
          unit="%"
          slot="value-with-unit2"
        />
      </section3>
    </div>

    <!-- 健康ための正しい生活習慣 -->
    <div class="content-wrapper">
      <section45 class="content--left">
        <heading
          :title="$i18n.t('aiPredictionReport.guidelinesForHealthyLiving')"
          slot="heading"
        />

        <display-value
          :value="$t('aiPredictionReport.leadAHealthyLife')"
          slot="text"
        />

        <display-text
          :text="$t(`aiPredictionReport.guidelines.${topRiskDiseaseCode}`)"
          slot="sentense"
        />
      </section45>

      <!-- おすすめする追加検査 -->
      <section45 class="content--right">
        <heading
          :title="$i18n.t('aiPredictionReport.recommendedTests')"
          slot="heading"
        />

        <display-value
          :value="$t('aiPredictionReport.weRecommendThatTheFollowingTests')"
          slot="text"
        />

        <display-text
          :text="$t(`aiPredictionReport.recommendedTest.${topRiskDiseaseCode}`)"
          slot="sentense"
        />
      </section45>
    </div>

    <!--　SelvyCheckUpロゴ画像-->
    <img
      src="../../static/svg/poweredbyselvy.svg"
      alt="selvycheckup"
      class="selvy-logo"
    />
  </div>
</template>

<script>
//atoms
import Heading from "../components/atoms/AIDiseasePredictionReport/Heading";
import DisplayValue from "../components/atoms/displayValue/DisplayValue";
import DisplayText from "../components/atoms/displayValue/DisplayText";
import HeaderTitle from "../design/HeaderTitleSlot";

//molecules
import DiseaseRiskCard from "../components/molecules/AIDiseasePredictionReport/DiseaseRiskCard";
import AverageSurvivalRateText from "../components/molecules/AIDiseasePredictionReport/AverageSurvivalRateText";
import DifferenceFromRealAge from "../components/molecules/AIDiseasePredictionReport/DifferenceFromRealAge";
import ValueWithUnit from "../components/molecules/AIDiseasePredictionReport/ValueWithUnit";
import UserSurvivalRateText from "../components/molecules/AIDiseasePredictionReport/UserSurvivalRateText";

// organisms
import Section1 from "../components/organisms/AIDiseasePredictionReport/Section1";
import Section2 from "../components/organisms/AIDiseasePredictionReport/Section2";
import Section3 from "../components/organisms/AIDiseasePredictionReport/Section3";
import Section45 from "../components/organisms/AIDiseasePredictionReport/Section45";

import LineChartHealthAge from "../plugin/chart/LineChartHealthAge";

export default {
  components: {
    // atoms
    Heading,
    DisplayValue,
    DisplayText,
    HeaderTitle,

    //molecules
    DiseaseRiskCard,
    AverageSurvivalRateText,
    DifferenceFromRealAge,
    ValueWithUnit,
    UserSurvivalRateText,

    // organisms
    Section1,
    Section2,
    Section3,
    Section45,

    LineChartHealthAge,
  },
  created() {
    // Firebaseから、診断結果のデータを全て取得
    this.fetchSelvyData(this.$store.state.auth.user.uid);
  },
  computed: {
    getDiagnosisDate() {
      return this.$store.getters["selvy/getDiagnosisDate"];
    },
    healthAge: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      return this.$store.getters["selvy/getHealthAge"];
    },
    realAge: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      return this.$store.getters["selvy/getRealAge"];
    },
    genderCode: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      return this.$store.getters["selvy/genderCode"];
    },
    userName: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return "";
      }
      return this.$store.getters["selvy/getName"];
    },
    averageExpectedSurvivalRate: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      return this.$store.getters["selvy/getDeathScore"];
    },
    userExpectedSurvivalRate: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      return this.$store.getters["selvy/getDeathStatistics"];
    },
    diseaseRiskCards: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return [];
      }
      return this.$store.getters["selvy/getDiseaseRisks"];
    },
    /* 最もリスク率の高い病気のコードを取得する */
    topRiskDiseaseCode: function() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return [];
      }
      let arr = this.$store.getters["selvy/getDiseaseRisks"];
      return arr.slice().sort((a, b) => {
        if (a.risk_rate > b.risk_rate) return -1;
        if (a.risk_rate < b.risk_rate) return 1;
        return 0;
      })[0].disease;
    },
  },
  methods: {
    fetchSelvyData() {
      this.$store.dispatch(
        "selvy/fetchSelvyFromFirebase",
        this.$store.state.auth.user.uid
      );
    },
  },
  filters: {
    round(value) {
      return Math.round(value * 10) / 10;
    },
    round2(value) {
      return Math.round(value * 100) / 100;
    },
  },
};
</script>

<style scoped>
/* レポートヘルプ */
.prediction-report-wrapper {
  width: 850px;
  margin: 0 auto;
  box-sizing: border-box;
}
/** 健康年齢など */
.content-wrapper {
  display: flex;
  margin-top: 40px;
  width: 100%;
  box-sizing: border-box;
}
.content--left {
  width: 50%;
  margin-right: 20px;
}
.content--right {
  width: 50%;
}

.selvy-logo {
  width: calc(100vw / 2);
}
.disease-risk-card {
  margin-right: 15px;
  margin-top: 10px;
}
/** スマホ */
@media screen and (max-width: 599px) {
  .prediction-report-wrapper {
    width: 100%;
    margin: 20px auto;
  }
  .content-wrapper {
    flex-direction: column;
  }
  .content--left {
    width: 100%;
    margin-right: 0px;
  }
  .content--right {
    width: 100%;
  }
}
/** タブレット */
@media screen and (min-width: 600px) and (max-width: 959px) {
  .prediction-report-wrapper {
    width: 100%;
    margin: 20px auto;
  }
}
/** PC */
@media screen and (min-width: 960px) {
  .selvy-logo {
    width: calc(100vw / 3);
  }
}
</style>
